import { render, staticRenderFns } from "./RenameModal.vue?vue&type=template&id=ca979484&scoped=true"
import script from "./RenameModal.vue?vue&type=script&lang=js"
export * from "./RenameModal.vue?vue&type=script&lang=js"
import style0 from "./RenameModal.vue?vue&type=style&index=0&id=ca979484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca979484",
  null
  
)

export default component.exports